import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronLeft, Scale } from "lucide-react";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Terms() {
  const { t } = useTranslation();
  return (
    <div className="relative min-h-screen hero-radial grain">
      <header className="relative z-30 flex items-center justify-between px-6 sm:px-10 py-5">
        <Link to="/" className="flex items-center gap-2 text-stone-300 hover:text-amber-200" data-testid="back-home">
          <ChevronLeft className="w-4 h-4" /> {t("common.back_home")}
        </Link>
        <div className="flex items-center gap-2 font-serif text-lg">
          <Scale className="w-5 h-5 text-amber-300" /> {t("legal.terms_title")}
        </div>
        <LanguageSwitcher />
      </header>
      <main className="relative z-10 max-w-3xl mx-auto px-6 sm:px-10 pb-20 space-y-6 text-stone-200" data-testid="terms-content">
        <h1 className="font-serif text-4xl font-black text-stone-50">{t("legal.terms_title")}</h1>
        <p className="text-xs uppercase tracking-widest text-amber-300 font-bold">{t("legal.updated_on")} 2026-03-02</p>
        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.terms_use_h")}</h2>
          <p>{t("legal.terms_use_p")}</p>
        </section>
        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.terms_account_h")}</h2>
          <p>{t("legal.terms_account_p")}</p>
        </section>
        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.terms_content_h")}</h2>
          <p>{t("legal.terms_content_p")}</p>
        </section>
        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.terms_payment_h")}</h2>
          <p>{t("legal.terms_payment_p")}</p>
        </section>
        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.terms_liability_h")}</h2>
          <p>{t("legal.terms_liability_p")}</p>
        </section>
        <section className="space-y-3">
          <h2 className="font-serif text-2xl font-bold text-stone-50">{t("legal.terms_contact_h")}</h2>
          <p><a href="mailto:legal@chronostimepuzzle.com" className="text-amber-300 hover:text-amber-200 underline" data-testid="terms-email">legal@chronostimepuzzle.com</a></p>
        </section>
      </main>
    </div>
  );
}
